// extracted by mini-css-extract-plugin
module.exports = {"root":"CreateShutdownForm_root__13FFB"};